module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACYSURBVHgB7ZBBCoJQEIa/EQ/QMsjF21d36Qh1Eu0kHalFiNuCPED78jVST+ThUxGX/jAwzPwf8zMwtwo2l1wrtI9DUIUcrPYKs6U8+R7pgj46t8j9Z7BGTdaHoy5oR3l0s7rXy+LHbsArZvVGXm2oDWv0R8HaMKQbSVZXaB8xUQvYI3Ev3/PMxgDOP/li/KfTnCQdC1Vw/gJCiiz4qrxsHgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/upload2.png
// module id = RpsA
// module chunks = 36